import { Directive, ElementRef, Renderer2, DoCheck, Input, OnChanges } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appErrorMessage]'
})
export class ErrorMessageDirective implements DoCheck {
  static validationErrorMessages: string;
  isProcessing: boolean = false;
  @Input('appErrorMessage') control: AbstractControl;
  // error: {
  //     alphaNumeric: boolean, required: boolean, whitespace: boolean, unique: boolean,
  //     numeric: boolean
  // };
  constructor(private renderer: Renderer2, private elementRef: ElementRef) {
    // if (ErrorMessageDirective.validationErrorMessages === undefined) {
    //   ErrorMessageDirective.validationErrorMessages = TranslationService.translate('eiInformationRequired');
    // }
  }

  ngDoCheck() {
    if(!this.isProcessing){
      this.isProcessing = true;
      this.getErrorMessages();
      this.isProcessing = false;
    }
  }

  getErrorMessages() {
    const element = this.elementRef.nativeElement;
    this.removeNextElement(element);

    if (this.control && (this.control.dirty || this.control.touched)) {
      if (this.control.errors) {
        const errors = this.control.errors;

        // if (element.className.indexOf('has-error') !== -1) {
        if (errors.alphaNumeric) {
          this.insertAdjacentHTML(element, ErrorMessages.alphaNumeric);
        }

        if (errors.pattern) {
          this.insertAdjacentHTML(element, ErrorMessages.pattern);
        }

        if (errors.unique) {
          this.insertAdjacentHTML(element, ErrorMessages.unique);
        }

        if (errors.whitespace || errors.required) {
          this.insertAdjacentHTML(element, ErrorMessages.required);
        }

        if (errors.numeric) {
          this.insertAdjacentHTML(element, ErrorMessages.numeric);
        }

        if (errors.email) {
          this.insertAdjacentHTML(element, ErrorMessages.email);
        }
        if (errors.duplicate) {
          this.insertAdjacentHTML(element, ErrorMessages.duplicate);
        }
      }
    }
  }

  insertAdjacentHTML(element: any, errorMessage: ErrorMessages) {
    element.insertAdjacentHTML('afterend', '<span class="invalid-msg">' + errorMessage + '</span>');
  }

  // Removes the next element to the element passed to this method. Here it removes all the error message elements.
  removeNextElement(element: any) {
    if (element && element.nextElementSibling && element.nextElementSibling.innerText &&
        (element.nextElementSibling.innerText === ErrorMessages.alphaNumeric
          || element.nextElementSibling.innerText === ErrorMessages.pattern
          || element.nextElementSibling.innerText === ErrorMessages.required
          || element.nextElementSibling.innerText === ErrorMessages.numeric
          || element.nextElementSibling.innerText === ErrorMessages.unique
          || element.nextElementSibling.innerText === ErrorMessages.email
          || element.nextElementSibling.innerText === ErrorMessages.duplicate)) {
        element.nextElementSibling.remove(element.nextElementSibling);
        this.removeNextElement(element);
    }
    else return;
  }
}

export enum ErrorMessages {
  alphaNumeric = 'Special character(s) are not allowed',
  pattern = 'Please insert correct format of the value',
  unique = 'Duplicate value(s) are not allowed',
  whitespace = 'This is a mandatory field',
  required = 'This is a mandatory field',
  numeric = 'Please insert correct format of the value',
  email = 'Please insert correct format of value for this field',
  duplicate = 'Duplicate value(s) are not allowed',
  favSampleDuplicate = 'This favorite sample name already exist, please enter a new name for this sample.',
}
